module.exports = __webpack_public_path__ + "img/86.0acc5091.jpg";